import deepmerge from 'deepmerge';
import { validateField } from '../validators';
import { CITIZENSHIP } from '../constants/citizenship';
import { getApplicantElkDocument } from '../selectors/elk';
import { DOCUMENT_FIELD } from '../constants/document';
import { getPersonCitizenship } from '../selectors/person';

const citizenship = {
  state: {
    citizenship: { value: null, disabled: false, error: false },
  },
  reducers: {
    'citizenship/set'(state, { payload: value }) {
      return { ...state, citizenship: { ...state.citizenship, value } };
    },

    'citizenship/set/disabled'(state, { payload }) {
      return { ...state, disabled: payload || !state.disabled };
    },
    'citizenship/set/error'(state, { payload }) {
      return { ...state, error: payload || !state.error };
    },
    'citizenship/validation/result'(state, { payload }) {
      const { personState, fieldValue } = payload;

      return deepmerge(personState, fieldValue);
    },
  },
  effects: {
    *'citizenship/validate'({ type, payload }, { select, put }) {
      const [modelNamespace] = type.split('/');
      const state = yield select((state) => state);
      const fieldValue = validateField(type, state);

      const personState = yield select((state) => state[modelNamespace]);
      yield put({
        type: 'citizenship/validation/result',
        payload: { personState, fieldValue },
      });
    },
    *'citizenship/set/value'({ type, payload: citizenship }, { select, put }) {
      const [model] = type.split('/');
      const previousCitizenshipValue = yield select((state) =>
        getPersonCitizenship({ person: state[model] })
      );

      const shouldResetDocuments =
        !previousCitizenshipValue ||
        [previousCitizenshipValue, citizenship].includes(CITIZENSHIP.CITIZEN);

      if (model === 'applicant') {
        if (shouldResetDocuments) {
          yield put({ type: 'dul/reset', payload: citizenship });
        }

        if (citizenship === CITIZENSHIP.CITIZEN) {
          const dul = yield select(getApplicantElkDocument);
          yield put({
            type: 'document/set',
            documentField: DOCUMENT_FIELD.dul,
            payload: dul,
          });
        }
        yield put({ type: 'citizenship/set', payload: citizenship });
        yield put({ type: 'form/saveDraft' });
        return;
      }

      if (model === 'child' && shouldResetDocuments) {
        yield put({ type: 'dul/reset', payload: citizenship });
        yield put({ type: 'check/birthdate/error' });
      }
      if (shouldResetDocuments) {
        yield put({ type: 'dul/reset', payload: citizenship });
      }
      yield put({ type: 'citizenship/set', payload: citizenship });
      yield put({ type: 'check/birthdate/error' });
      yield put({
        type: `${model}/passport/validity`,
      });
      yield put({ type: 'form/saveDraft' });
    },
  },
};

export default citizenship;
